function handleTabClickEvent(event) {
  if ($(window).width() > 576 || $(event.currentTarget).closest(".enable-mobile")) {

      var $target = $(event.currentTarget);
      var $oldTarget = $target.closest(".tab-component").find(".tab-component__button--active");
      var $targets = $target.closest(".tab-component").find(".tab-component__button");

      if ($target.hasClass("tab-component__button--active")) return;

      $targets.removeClass("easy-out-button");

      $oldTarget.addClass("easy-out-button")
          .removeClass("easy-in-button-left")
          .removeClass("easy-in-button-right");

      $target.closest(".tab-component")
          .find(".tab-component__button")
          .removeClass("tab-component__button--active");

      $target.closest(".reference-tab-component")
          .find(".tab-content")
          .removeClass("tab-content--active");

      if ($oldTarget.index() < $target.index()) {
          $target.addClass("easy-in-button-left");
      } else {
          $target.addClass("easy-in-button-right");
      }

      $target.addClass("tab-component__button--active");

      $target.closest(".reference-tab-component")
          .find(".tab-content:eq(" + $target.index() + ")")
          .addClass("tab-content--active");
  }
}


 
$(document).ready(function () {
  $('.js-related-Product__slide').on('click' , '.data-href', function(e){
    $('.js-related-Product__slide .data-href').removeClass('active');
    var url = $(this).attr('data-href');
   $( "#wrap-item-data" ).css({opacity: 0.5 , background: "#e3e3e3"});
   $( ".bundle-product-loader" ).removeClass("hidden");
    $( "#wrap-item-data" ).load( url + " .reference-tab-component.product-details-content.enable-mobile",  function( response, status, xhr ) {
      if ( status == "error" ) {
        var msg = "Sorry but there was an error: "; 
        $( "#wrap-item-data" ).html( msg + xhr.status + " " + xhr.statusText );
      }
      if ( status == "success" ) {
       
        setTimeout(() => {
          $( ".bundle-product-loader" ).addClass("hidden");
          $( "#wrap-item-data" ).fadeIn("slow", function(){ 
            $( "#wrap-item-data" ).css({opacity: 1 , background: "transparent"});
        });
        }, 500);
      }
    });
    $(this).addClass('active');  
   
   
  })  
  $('body').on('click','.js-tab-component .tab-component__button', handleTabClickEvent);
  
  
    $('.js-related-Product__slide:not(.slick-cloned) .data-href').first().trigger('click');
  
});